import * as u from '../utils';

export default () => {
    const link = document.querySelector('.header__basket');
    const counter = document.querySelector('.header__basket-count');

    if (!link) {
        return;
    }

    // Format request data
    const data = new FormData();
    data.append('action', 'basket_total_request');
    data.append('security', WP.nonce);

    // Send the request
    let responseStatus;

    fetch(WP.ajax, {
        method: 'POST',
        body: data,
    })
        .then((response) => {
            responseStatus = response.status;
            return response.json();
        })
        .then((response) => {
            switch (responseStatus) {
                case 200:
                case 201:
                case 202:
                    if (response.data.count) {
                        counter.innerHTML = response.data.count;
                        u.addClass(link, 'is-active');
                        u.addClass(counter, 'is-active');
                    }
                    break;
                default:
                    break;
            }
        })
        .catch(() => {
            console.warn('Error loading basket count'); // eslint-disable-line no-console
        });
};
